import { __decorate } from "tslib";
import { observer } from 'mobx-react';
import { NumberField } from '../number-field/NumberField';
import { FieldType } from '../data-set/enum';
import formatCurrency from '../formatter/formatCurrency';
import { getCurrencyFormatOptions, getCurrencyFormatter } from '../field/utils';
let Currency = class Currency extends NumberField {
    getFieldType() {
        return FieldType.currency;
    }
    getFormatter() {
        return this.getProp('formatter') || getCurrencyFormatter();
    }
    getFormatOptions() {
        return getCurrencyFormatOptions((name) => this.getProp(name), this.lang);
    }
};
Currency.displayName = 'Currency';
Currency.format = formatCurrency;
Currency = __decorate([
    observer
], Currency);
export default Currency;
